import styled, { keyframes } from 'styled-components';

export const MapStyled = styled.div`
  width: 100vw;
  height: 40vh;
  background: #ededed;
  overflow: auto;
  padding: 2rem;

  .image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      display: block;
    }
  }
`;

const markerEffect = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.5);
  }
`;

export const Marker = styled.div<{
  left: number;
  top: number;
  background: string;
}>`
  position: absolute;
  left: ${props => props.left}px;
  top: ${props => props.top}px;
  width: 14px;
  height: 14px;
  background: ${props => props.background};
  border-radius: 50%;

  &:after {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 19px;
    height: 19px;
    border: 1px solid ${props => props.background};
    border-radius: 50%;
    animation: ${markerEffect} 1s infinite linear;
    content: '';
  }
`;
